// extracted by mini-css-extract-plugin
export default {"image-box":"fillBlank_image-box__gAWt7","submit-box":"fillBlank_submit-box__q0aSD","header":"fillBlank_header__vt8Zr"};